import { useMemo } from "react";

import { useMessengerContext } from "./__internal__/MessengerContext";

export const useMessengerStoreIsLoadingConversations = (): {
  isLoadingConversations: boolean;
} => {
  const isLoadingCount =
    useMessengerContext(({ isLoadingCount }) => isLoadingCount) ?? 0;
  return useMemo(
    () => ({
      isLoadingConversations: isLoadingCount > 0,
    }),
    [isLoadingCount]
  );
};
